import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Star } from "lucide-react";
import { cva } from "class-variance-authority";
import { cn } from "../../../utils";
const scoreBadgeVariants = cva("inline-flex items-center gap-1.5 font-medium", {
    variants: {
        variant: {
            simple: "",
            boxed: "px-3 py-1.5 rounded-md border"
        },
        size: {
            sm: "text-sm [&_svg]:h-3.5 [&_svg]:w-3.5",
            default: "text-sm [&_svg]:h-4 [&_svg]:w-4",
            lg: "text-lg [&_svg]:h-5 [&_svg]:w-5"
        }
    },
    defaultVariants: {
        variant: "simple",
        size: "default"
    }
});
const defaultThresholds = [
    {
        min: 4.0,
        color: "emerald"
    },
    {
        min: 3.5,
        color: "gray"
    },
    {
        min: 0,
        color: "amber"
    }
];
// Static class maps — Tailwind can't detect dynamically constructed class names
const colorClassMap = {
    emerald: {
        boxed: "bg-positive-surface border-positive-line text-positive",
        simple: "text-positive"
    },
    gray: {
        boxed: "bg-surface-subtle border-line text-fg-secondary",
        simple: "text-fg-secondary"
    },
    amber: {
        boxed: "bg-warning-surface border-warning-line text-warning",
        simple: "text-warning"
    }
};
function getScoreColors(value, variant, colorScheme, thresholds) {
    const v = variant === "boxed" ? "boxed" : "simple";
    if (value === null) {
        return variant === "boxed" ? "bg-surface-subtle border-line text-fg-subtle" : "text-fg-disabled";
    }
    if (colorScheme === "static") {
        return variant === "boxed" ? "bg-warning-surface border-warning-line text-foreground [&_svg]:text-warning" : "text-foreground [&_svg]:text-warning";
    }
    for (const threshold of thresholds){
        if (value >= threshold.min) {
            const classes = colorClassMap[threshold.color];
            if (classes) return classes[v];
            return colorClassMap.gray[v];
        }
    }
    return colorClassMap.gray[v];
}
export function ScoreBadge({ value, icon: Icon = Star, thresholds = defaultThresholds, variant = "simple", size = "default", className, colorScheme = "static" }) {
    const colorClasses = getScoreColors(value, variant, colorScheme, thresholds);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(scoreBadgeVariants({
            variant,
            size
        }), colorClasses, className),
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                className: cn("fill-current", value === null && "fill-none")
            }),
            /*#__PURE__*/ _jsx("span", {
                children: value !== null ? value.toFixed(1) : "-"
            })
        ]
    });
}

//# sourceMappingURL=score-badge.js.map